<button class="cb-margin-right" mat-raised-button color="primary" [matMenuTriggerFor]="actionsMenu">
    <mat-icon>arrow_drop_down</mat-icon>
    &nbsp;Actions
</button>
<mat-menu #actionsMenu="matMenu">
    @if (canChangeSpecification()) {
        <button mat-menu-item [disabled]="lotSpec.isLocked" (click)="addLotSpecItem()">
            Add Item
        </button>
    }
    @if (canChangeSpecification() && !lotSpec?.lotSpecScheduleItems?.length) {
        <button mat-menu-item (click)="addLotSpecColourItem()">Add Colour Item</button>
    }
    @if (canSetAttributeValue()) {
        <button
            mat-menu-item
            [disabled]="disableExpandAllAndFilterAndManageColourItems()"
            (click)="openManageAttributesDialog()"
        >
            Manage Attribute Items
        </button>
    }
    @if (canSetAttributeValue()) {
        <button
            mat-menu-item
            [disabled]="disableExpandAllAndFilterAndManageColourItems()"
            (click)="manageLotSpecHouseItems()"
        >
            Manage Colour Schedule
        </button>
    }
    @if (isSIMSchedule()) {
        <button
            mat-menu-item
            [disabled]="disableExpandAllAndFilterAndManageColourItems()"
            (click)="manageCreateScheduleLotSpecHouseItems()"
        >
            Manage Flyer / Create Schedule
        </button>
    }
    @if (canChangeSpecification()) {
        <button mat-menu-item [disabled]="!canClearLotSpec()" (click)="clearLotSpec()">
            <mat-icon>delete</mat-icon>
            &nbsp;Clear Lot Specification
        </button>
    }
</mat-menu>
